<template>
  <ProgressSpinnerContainer/>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from "vue-router";
import ProgressSpinnerContainer from "../ProgressSpinnerContainer.vue";

const router = useRouter()
const { error } = useAuth0();

router.push('/')
</script>